import UrlModules from '$common/utils/curl/browser-curl/url-modules';
// 输出环境变量sit，uat， pro
export const currentEnv = () => {
  let appgateway = new UrlModules({ module: 'appgateway' })
  return appgateway.env
}
export const baseTinhnowUrl = `https://tinhnow{env}.wownow.net/h5`;
// 根据不同环境，获取跳转电商H5的域名
export const getTinhHost = () => {
  let env = currentEnv()
  if (env === 'pro') {
    return baseTinhnowUrl.replace(/{env}/g, ``);
  }
  return baseTinhnowUrl.replace(/{env}/g, `-${env}`);
}